import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-console */

import { isLocalstorageAvailable, willSendToSentry } from './utils';
var isExtendedError = function isExtendedError(error) {
  return error instanceof Error;
};
export default (function (_ref, inject) {
  var app = _ref.app;
  if (app.$sentry) {
    var _app$store;
    // Set user info for sentry
    var setUser = function setUser(auth) {
      var user = auth === null || auth === void 0 ? void 0 : auth.user;
      var person = user !== null && user !== void 0 && user.id ? {
        id: user.id,
        email: user.email,
        username: user.autoName
      } : null;
      if (person) {
        app.$sentry.setUser(person);
      }
    };
    (_app$store = app.store) === null || _app$store === void 0 ? void 0 : _app$store.watch(function (store) {
      return store.auth;
    }, setUser, {
      immediate: true
    });

    // Set context tag
    app.$sentry.setTag('context', process.client ? 'client' : 'server');
  }
  var pushError = function pushError(error, data) {
    var _error$response, _error$response2;
    if (!isExtendedError(error)) return false;
    var statusCode = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || error.status;
    var message = ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusText) || error.statusText || error.message;
    var fullstoryLink;
    if (typeof data === 'string') {
      // eslint-disable-next-line
      data = {
        info: data
      };
    }
    if (process.client) {
      try {
        var _window$FS;
        fullstoryLink = (_window$FS = window.FS) === null || _window$FS === void 0 ? void 0 : _window$FS.getCurrentSessionURL();
      } catch (e) {}
    }
    if (app.$sentry) {
      if (willSendToSentry(error)) {
        app.$sentry.captureException(error, {
          extra: _objectSpread(_objectSpread(_objectSpread({
            statusCode: statusCode,
            message: message
          }, process.client && {
            hasSupport: {
              cookies: navigator.cookieEnabled,
              localStorage: isLocalstorageAvailable
            }
          }), fullstoryLink && {
            fullstoryLink: fullstoryLink
          }), data)
        });
      }
    } else {
      console.error(error);
    }
    return {
      statusCode: statusCode,
      message: message
    };
  };
  inject('sentryUtils', {
    error: pushError
  });
});